import { render, staticRenderFns } from "./dev-statistics.vue?vue&type=template&id=3ad98406"
import script from "./dev-statistics.vue?vue&type=script&lang=ts"
export * from "./dev-statistics.vue?vue&type=script&lang=ts"
import style0 from "./dev-statistics.vue?vue&type=style&index=0&id=3ad98406&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports